export var GLOBAL_SEARCH_ITEMS;
(function (GLOBAL_SEARCH_ITEMS) {
    GLOBAL_SEARCH_ITEMS["FLEET_ORDER_ITEM"] = "orders";
    GLOBAL_SEARCH_ITEMS["URBAN_ORDER_ITEM"] = "urban-orders";
    GLOBAL_SEARCH_ITEMS["CONTACT_ITEM"] = "contacts";
    GLOBAL_SEARCH_ITEMS["MECHANICAL_CARE_ITEM"] = "mechanical-care";
    GLOBAL_SEARCH_ITEMS["ONCALL_ITEM"] = "on-call";
})(GLOBAL_SEARCH_ITEMS || (GLOBAL_SEARCH_ITEMS = {}));
//# sourceMappingURL=GlobalSearch.js.map